import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getInstance } from '../common/cache';
import { getLocalStorageItem, setLocalStorageItem } from '../common/persist-helpers';
/**
 * Cache implementation which always returns the persited response (if available).
 * But refreshes the response everytime its requested, so that next time onwards the data is up to date.
 *
 * Note - This will also return an expired result. This strategy should be used only in scenarios where:
 * 1. The data changes rarely.
 * 2. Its fine to serve the expired result to the user.
 */
export var promiseCache = function promiseCache(args) {
  var name = args.name;
  var cacheInstance = getInstance(args);
  var persistedState = getLocalStorageItem(name);
  if (persistedState) {
    cacheInstance.deserialize(persistedState);
  }
  var get = function get(key, returnExpired) {
    var storedValue = cacheInstance.get(key, returnExpired !== null && returnExpired !== void 0 ? returnExpired : true); // fetch expired result by default
    var isExpired = cacheInstance.isExpired(key);
    return {
      storedValue: storedValue,
      isExpired: isExpired
    };
  };
  var set = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, result, expiration) {
      var serialized;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cacheInstance.set(key, result, expiration);
            _context.next = 3;
            return result;
          case 3:
            _context.next = 5;
            return cacheInstance.serialize();
          case 5:
            serialized = _context.sent;
            setLocalStorageItem(name, serialized);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function set(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var refreshOnAccessDecorator = function refreshOnAccessDecorator(_ref2) {
    var key = _ref2.key,
      supplier = _ref2.supplier,
      returnExpired = _ref2.returnExpired,
      onlyRefreshIfExpired = _ref2.onlyRefreshIfExpired,
      expiration = _ref2.expiration;
    var _get = get(key, returnExpired),
      storedValue = _get.storedValue,
      isExpired = _get.isExpired;
    var shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
    if (!storedValue || shouldRefresh) {
      var apiPromise = supplier();
      set(key, apiPromise, expiration);

      // If there was already a stored value prior to refreshing, return it
      return storedValue || apiPromise;
    } else {
      return storedValue;
    }
  };
  return {
    get: get,
    refreshOnAccessDecorator: refreshOnAccessDecorator
  };
};